module.exports = __webpack_public_path__ + "assets/images/project/head/Louise_Emmanuelle_Mabulo.jpg?v=95cdca5c";